import React, { useState } from "react";
import { Link, useNavigate, useLocation, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  LayoutGrid,
  Receipt,
  Users,
  UserCheck,
  ArrowLeftRight,
  Send,
  RadioTower,
  ShieldCheck,
  LogOut,
  Menu,
  X,
  ArrowUpDown,
  UsersRoundIcon,
  Image,
} from "lucide-react";

const NAV = [
  { to: "/border-tax-orders", label: "Border Tax Pay", icon: LayoutGrid },
  { to: "/border-tax-orders?onlyshow=assignedtome", label: "Assigned Border Tax", icon: UserCheck },
  { to: "/border-tax-orders?onlyshow=transferredbyme", label: "Transfer Border Tax (By Own)", icon: ArrowLeftRight },
  { to: "/border-tax-new", label: "All New Tax (3 Month , Road tax & AITP Authorisation)", icon: Receipt },
  { to: "/transferd-tax-new", label: "3 Month Tax Transfer History", icon: ArrowLeftRight },
  { to: "/aipt-transferd-tax-new", label: "AITP Authorisation Transfer History", icon: RadioTower },
  { to: "/road-transferd-tax-new", label: "Road Tax Pay Transfer History", icon: ArrowLeftRight },
  { to: "/providers", label: "Providers", icon: Users },
  { to: "/provider/tax-stats", label: "New Tax Stats Analytics", icon: ArrowUpDown, },
  { to: "/border-tax/ui", label: "Border Tax Ui", icon: Image, },


  { to: "/assign-border-all-new-tax", label: "Assign Border All", icon: UsersRoundIcon },
  { to: "/border-tax", label: "Border And State", icon: Receipt },
];
const Layout = () => {
  const { employee, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const isActive = (to) => {
    const [path, query] = to.split("?");
    if (location.pathname !== path) return false;
    if (!query) return true;
    return location.search.replace("?", "") === query;
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Mobile overlay */}
      {open && (
        <div
          className="fixed inset-0 bg-black/40 z-30 lg:hidden"
          onClick={() => setOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed lg:static z-40 top-0 left-0 h-full w-64 bg-white border-r border-gray-200 flex flex-col transition-transform duration-200 ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
          }`}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-indigo-600 flex items-center justify-center">
              <ShieldCheck className="w-4 h-4 text-white" />
            </div>
            <span className="font-semibold text-gray-900">Border Tax Employer</span>
          </div>
          <button
            className="lg:hidden text-gray-500"
            onClick={() => setOpen(false)}
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <nav className="flex-1 overflow-y-auto py-3 px-3 space-y-1">
          {NAV.map(({ to, label, icon: Icon }) => {
            const active = isActive(to);
            return (
              <Link
                key={to}
                to={to}
                onClick={() => setOpen(false)}
                className={`flex items-center gap-3 px-1 py-2.5 rounded-lg text-sm font-medium transition-colors ${active
                  ? "bg-indigo-50 text-indigo-700"
                  : "text-gray-600 hover:bg-gray-50 hover:text-indigo-600"
                  }`}
              >
                <Icon className="w-4 h-4 shrink-0" />
                <span className="truncate">{label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="border-t border-gray-200 p-4">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-xs font-semibold text-gray-600">
              {employee?.name?.charAt(0)?.toUpperCase() || "U"}
            </div>
            <div className="min-w-0">
              <p className="text-sm font-medium text-gray-900 truncate">
                {employee?.name}
              </p>
              <span className="text-xs px-2 py-0.5 bg-indigo-50 text-indigo-700 rounded-full">
                {employee?.role}
              </span>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium text-red-600 hover:bg-red-50"
          >
            <LogOut className="w-4 h-4" />
            Logout
          </button>
        </div>
      </aside>

      {/* Main */}
      <div className="flex-1 min-w-0 flex flex-col">
        <header className="lg:hidden flex items-center gap-3 bg-white border-b border-gray-200 px-4 py-3">
          <button onClick={() => setOpen(true)} className="text-gray-600">
            <Menu className="w-5 h-5" />
          </button>
          <span className="font-semibold text-gray-900">Border Tax Employer</span>
        </header>

        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;